export const componentRef = 'typesense-search';
